/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import {
  Component, Inject, Input, OnInit,
} from '@angular/core';

/**
 * Generic component for showing error messages to end user.
 */
@Component({
  selector: 'bulb-error',
  templateUrl: './error.component.html',
  standalone: false,
})
export class ErrorComponent implements OnInit {
  /**
   * Title of the exception.
   */
  @Input() errorTitle: string;

  /**
   * Short description for the exception.
   */
  @Input() errorDescription: string;

  /**
   * Error code of the exception.
   */
  @Input() errorCode: string;

  /**
   * Is user authenticated.
   */
  isAuthenticated: boolean;

  /**
   * Default Constructor.
   * @param bulbAuthService
   */
  constructor(@Inject('BulbAuthService') private bulbAuthService) {
  }

  /**
   * A lifecycle hook that is called after Angular has initialized.
   */
  ngOnInit(): void {
    this.isAuthenticated = this.bulbAuthService.currentUser.isAuthenticated();
  }
}
